import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { MainService } from "../../main.service";

@Component({
  selector: "app-question-list",
  templateUrl: "./question-list.component.html",
  styleUrls: ["./question-list.component.css"],
})
export class QuestionListComponent implements OnInit {
  id: any = "";
  isLoading: boolean = false;
  scholarshipsList: any = {};
  questList: any = [];
  scholardetail: any;
  disable: boolean = false;
  isSubmit: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private mainservice: MainService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getQuestionList();
    this.id = "";
    this.route.queryParams.subscribe((param) => {
      if (param["id"]) {
        this.id = param["id"];
        console.log(this.id);
        this.getScholarShipsList(this.id);
      } else {
        this.id = "";
      }
    });
  }
  getScholarShipsList(id) {
    this.isLoading = true;
    let query = "?scholarshipId=" + id;
    this.mainservice.getChoirApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.scholarshipsList = res.data.response[0];
          console.log(this.scholarshipsList);
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getQuestionList() {
    this.isLoading = true;
    let query = "";
    this.mainservice.getQuestions(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.questList = res.data.scholarshipQuestions;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  SubmitData() {
    this.isSubmit = true;
    let isValid: boolean = true;
    if (this.questList.length) {
      this.questList.forEach((element) => {
        if (element.isRequired && element.valuesText == "") {
          isValid = false;
          return;
        }
      });
    }
    if (isValid) {
      let req = {
        scholarshipQuestionAnswer: this.questList,
        scholarshipId: this.scholarshipsList["_id"],
      };
      this.isLoading = true;
      this.mainservice.submitQuestions(req).subscribe(
        (res) => {
          this.isLoading = false;
          if (res["message"] == "Success") {
            this.questList = [];
            this.getQuestionList();
            this.router.navigate(["/main/home"]);
            this._snackBar.open("Applied Successfully!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
}
